<template>
    <div class="tender-downloads-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="loading-spinner-outer" v-if="loading">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Loading, please wait
                </div>
            </div>
        </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Tender Downloads powered by Black ICE
                </div>
                <div class="logo">
                    <img src="/images/powered-by-logo-black-ice.png">
                </div>
            </div>
            <div class="box-1">
                <h1>Tender Portal</h1>
                <p>
                    Through this portal you can access all your tender documents and input whether you are tendering, pricing or have won the tender.
                </p>
                <div class="pb-1" v-if="!user_has_access">
                    <p>
                        <a class="btn-primary" @click.prevent="enquiry_box_open = true">
                            Request Account
                        </a>
                    </p>
                </div>
            </div>
            <black-ice-tenders-list :system_types="system_types" v-if="user_has_access"></black-ice-tenders-list>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Black ICE Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
        'system_types',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like some more information on signing up for a Black ICE account',
          sending: false,
          loading: true,
          user_has_access: false,
        }
    },
    mounted() {
      this.checkUserHasAccess();
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 14,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Black ICE enquiry',
                'value': 'Black ICE enquiry',
              });

                this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      checkUserHasAccess() {
        axios.get('/commercial/black-ice-api/getUser').then((response) => {
          this.loading = false;
          if(response.data === 'no_access') {
            this.user_has_access = false;
          } else {
            this.user_has_access = true;
          }
        });
      },
    },
};
</script>
